import { useQuery } from '@tanstack/react-query';
import { apiService } from '../../../../services/api';
import { EngineStartupFlight } from '../../../../types/api';

// STD-015: server state for engine startup events used by the HealthPanelTab.
// apiService is imported here (a *.queries.ts file) per STD-016. Errors were
// previously console.error-only, so this query opts out of the global toast.

export const engineStartupKeys = {
  all: ['engineStartup'] as const,
  byDrone: (serial: string) => [...engineStartupKeys.all, serial] as const,
};

export function useEngineStartupQuery(droneSerial: string | null): {
  flights: EngineStartupFlight[];
  isLoading: boolean;
  error: string | null;
} {
  const query = useQuery({
    queryKey: engineStartupKeys.byDrone(droneSerial ?? ''),
    enabled: !!droneSerial,
    meta: { skipGlobalErrorToast: true },
    queryFn: async (): Promise<EngineStartupFlight[]> => {
      const response = await apiService.getEngineStartupEvents(droneSerial!);
      return response.flights;
    },
  });

  return {
    flights: query.data ?? [],
    isLoading: query.isLoading,
    error: query.isError
      ? query.error instanceof Error
        ? query.error.message
        : 'Failed to load engine startup data'
      : null,
  };
}
